// extracted by mini-css-extract-plugin
export default {"root":"PointsAwardedNotification_root__VOM71","closeButton":"PointsAwardedNotification_closeButton__EEge-"};